import type { NoteDetail, UUID } from "@/core/types";
import { sharedRequestsTyped } from "@/api/(requests)/sharedTyped";

type GetNoteDetailsProps = {
  noteId: UUID;
  patientId: UUID;
};

export async function getNoteDetails({
  noteId,
  patientId,
}: GetNoteDetailsProps): Promise<NoteDetail> {
  return sharedRequestsTyped.fetch_patient_progress_notes({
    context: { showLoader: false },
    searchParams: { note_id: noteId },
    urlParams: { patientId },
  });
}
